import {NgModule} from "@angular/core";
import {HeadingComponent} from "./components/heading/heading.component";
import {CommonModule} from "@angular/common";
import {FormErrorComponent} from './components/form-error/form-error.component';
import {SelectModule} from 'primeng/select';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DialogModule} from "primeng/dialog";
import {LoadingComponent} from './components/loading-component/loading.component';
import {ErrorComponent} from "./components/error/error.component";
import {ProfileViewComponent} from './components/navigation/profile-view/profile-view.component';
import {AvatarModule} from "primeng/avatar";
import {TooltipModule} from "primeng/tooltip";
import {ModalComponent} from './components/modal/modal.component';
import {ButtonModule} from "primeng/button";
import {TextareaModule} from "primeng/textarea";
import {EventAdminFilterComponent} from './components/event/event-admin-filter/event-admin-filter.component';
import {InputTextModule} from "primeng/inputtext";
import {DatePickerModule} from "primeng/datepicker";
import {PaginatorComponent} from './components/paginator/paginator.component';
import {PaginatorModule} from "primeng/paginator";

import {FilePondModule, registerPlugin} from "ngx-filepond";

import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import {FileUploadComponent} from './components/file-upload/file-upload.component';
import {ImageRedactComponent} from './components/image-redact/image-redact.component';
import {EventFormComponent} from './components/event/event-form/event-form.component';
import {DocumentFormComponent} from "./components/event/event-form/document-form/document-form.component";
import {VehicleFormComponent} from "./components/event/event-form/vehicle-form/vehicle-form.component";
import {PersonFormComponent} from "./components/event/event-form/person-form/person-form.component";
import {KeyFilterModule} from "primeng/keyfilter";
import {AutoCompleteModule} from "primeng/autocomplete";
import {EditEventComponent} from "./components/event/edit-event/edit-event.component";
import {EditEventImageComponent} from './components/event/edit-event-image/edit-event-image.component';
import {TextTruncatePipe} from './pipes/text-truncate.pipe';
import {EventDropDownMenuComponent} from './components/event/event-drop-down-menu/event-drop-down-menu.component';
import {EventTableListComponent} from './components/event/event-table-list/event-table-list.component';
import {TableModule} from "primeng/table";
import {MenuModule} from "primeng/menu";
import {
  EventDetailInfoModalComponent
} from './components/modal/event-detail-info-modal/event-detail-info-modal.component';
import {ReportModalComponent} from './components/modal/report-modal/report-modal.component';
import {CheckboxModule} from "primeng/checkbox";
import {EventClosureModalComponent} from './components/modal/event-closure-modal/event-closure-modal.component';
import {EventTreatmentModalComponent} from './components/modal/event-treatment-modal/event-treatment-modal.component';
import {TextInputComponent} from './components/input/text-input/text-input.component';
import {PhoneNumberFieldComponent} from './components/input/phone-number-field/phone-number-field.component';
import {TextAreaInputComponent} from './components/input/text-area-input/text-area-input.component';
import {SelectInputComponent} from './components/input/select-input/select-input.component';
import {CalendarInputComponent} from './components/input/calendar-input/calendar-input.component';
import {TextChipInputComponent} from './components/input/text-chip-input/text-chip-input.component';
import {ImagePreviewComponent} from './components/image-preview/image-preview.component';
import {ImageComponent} from './components/image/image/image.component';
import {UserInfoModalComponent} from './components/modal/user-info-modal/user-info-modal.component';
import {AccessForbiddenComponent} from './components/access-forbidden/access-forbidden.component';
import {AccordionModule} from "primeng/accordion";
import {FloatLabelModule} from "primeng/floatlabel";
import {EventRemoveModalComponent} from "./components/modal/event-remove-modal/event-remove-modal.component";
import {
  EventRemoveReasonModalComponent
} from './components/modal/event-remove-reason-modal/event-remove-reason-modal.component';
import {AeButtonComponent} from './components/button/ae-button.component';
import {CustomButtonComponent} from './components/button/custom-button.component';
import {RouterModule} from '@angular/router';

registerPlugin(FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize)

@NgModule({
  declarations: [
    HeadingComponent,
    ErrorComponent,
    FormErrorComponent,
    LoadingComponent,
    ProfileViewComponent,
    ModalComponent,
    EventAdminFilterComponent,
    PaginatorComponent,
    FileUploadComponent,
    ImageRedactComponent,
    EventFormComponent,
    DocumentFormComponent,
    EditEventComponent,
    VehicleFormComponent,
    PersonFormComponent,
    EditEventImageComponent,
    TextTruncatePipe,
    EventDropDownMenuComponent,
    EventTableListComponent,
    EventDetailInfoModalComponent,
    ReportModalComponent,
    EventClosureModalComponent,
    EventTreatmentModalComponent,
    TextInputComponent,
    PhoneNumberFieldComponent,
    TextAreaInputComponent,
    SelectInputComponent,
    CalendarInputComponent,
    TextChipInputComponent,
    ImagePreviewComponent,
    ImageComponent,
    UserInfoModalComponent,
    AccessForbiddenComponent,
    EventRemoveModalComponent,
    EventRemoveReasonModalComponent,
    AeButtonComponent,
    CustomButtonComponent
  ],
  imports: [CommonModule,
    RouterModule,
    SelectModule,
    FilePondModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule, AvatarModule, TooltipModule, ButtonModule, TextareaModule, InputTextModule, DatePickerModule, PaginatorModule, KeyFilterModule, AutoCompleteModule, TableModule, MenuModule,     CheckboxModule, AccordionModule, FloatLabelModule
  ],
  exports: [
    CommonModule,
    FilePondModule,
    DialogModule,
    HeadingComponent,
    ErrorComponent,
    FormErrorComponent,
    LoadingComponent,
    ProfileViewComponent,
    ModalComponent,
    EventAdminFilterComponent,
    PaginatorComponent,
    FileUploadComponent,
    ImageRedactComponent,
    EventFormComponent,
    EditEventComponent,
    EditEventImageComponent,
    TextTruncatePipe,
    EventTableListComponent,
    EventDropDownMenuComponent,
    TextInputComponent,
    PhoneNumberFieldComponent,
    TextAreaInputComponent,
    ImagePreviewComponent,
    ImageComponent,
    CalendarInputComponent,
    SelectInputComponent,
    UserInfoModalComponent,
    EventRemoveModalComponent,
    TooltipModule,
    FloatLabelModule,
    AeButtonComponent,
    CustomButtonComponent
  ]
})
export class SharedModule {

}
